const { parseDomain } = require('parse-domain')
const languageMap = require('../../i18n/languageMap')

module.exports = hostname => {
  if (hostname.indexOf('localhost') !== -1) {
    return 'en'
  }

  const { topLevelDomains, subDomains } = parseDomain(hostname)
  let topLevelDomain = null

  try {
    topLevelDomain = topLevelDomains[0]
  } catch {
    console.log(`[ERROR] getLocaleFromHostname: ${hostname}`)
  }

  if (topLevelDomain === 'pizza') {
    let devLanguage = subDomains[0]

    if (devLanguage.indexOf('-') !== -1) {
      const parts = devLanguage.split('-')
      devLanguage = `${parts[0]}-${parts[1].toUpperCase()}`

      if (devLanguage === 'com-BR') {
        return 'pt-BR'
      }

      return devLanguage
    }

    const tld = devLanguage.split('-')[0]
    const subdomain = tld.split('-')[1] || 'www'
    return languageMap[`${subdomain}.ticketswap.${tld}`] || 'en'
  }

  return languageMap[hostname] || 'en'
}
